/* eslint-disable react-hooks/exhaustive-deps */
import {
  EditOutlined,
  ArrowUpOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Table, Button, message, Modal, Input } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { animateScroll as scroll } from "react-scroll";
import { apiClient } from "../Api/AllApi";

import "../Styles/ListPages.css";

const GetUnit = () => {
  const { t, i18n } = useTranslation();

  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [parentUnits, setParentUnits] = useState({});

  useEffect(() => {
    getApiUnitsWithParents();
  }, [i18n.language]); const getApiUnitsWithParents = async () => {
    try {
      const response = await apiClient.get("/units");
      const unitsData = response.data;

      // Create a map of all units for faster lookup
      const unitMap = {};
      unitsData.forEach(unit => {
        unitMap[unit.id] = unit;
      });

      // Fetch all parent units
      const parentUnitIds = [...new Set(unitsData.filter(unit => unit.parent_id).map(unit => unit.parent_id))];
      const fetchedParents = {};

      // First try to get parent units from the already fetched units data
      parentUnitIds.forEach(parentId => {
        if (unitMap[parentId]) {
          try {
            const parentUnit = unitMap[parentId];
            const nameObj = JSON.parse(parentUnit.name);
            fetchedParents[parentId] = nameObj[i18n.language] || nameObj.en || "N/A";
          } catch (error) {
            console.error(`Error parsing parent unit ${parentId} from cache:`, error);
            fetchedParents[parentId] = t("N/A");
          }
        }
      });

      // Only fetch parent units that weren't found in the initial units request
      const missingParentIds = parentUnitIds.filter(id => !fetchedParents[id]);
      for (const parentId of missingParentIds) {
        try {
          const parentResponse = await apiClient.get(`/units/${parentId}`);
          const parentData = parentResponse.data;
          const nameObj = JSON.parse(parentData.name);
          fetchedParents[parentId] = nameObj[i18n.language] || nameObj.en || "N/A";
        } catch (error) {
          fetchedParents[parentId] = t("N/A");
        }
      }

      setParentUnits(fetchedParents);

      const processedData = unitsData.map((item) => {
        let name = "N/A";
        try {
          const nameObj = JSON.parse(item.name);
          name = nameObj[i18n.language] || nameObj.en || "N/A";
        } catch (error) {
          console.error("Error parsing name JSON:", error);
        }
        return {
          id: item.id,
          name: name,
          parent_unit_id: item.parent_id,
        };
      });
      setDataSource(processedData);

    } catch (error) {
      message.error(t("Failed to load units"));
    }
  };

  // Delete item
  const handleDelete = (id) => {
    setDeleteItemId(id);
    setIsDeleteModalVisible(true);
  };
  const handleConfirmedDelete = async () => {
    try {
      await apiClient.delete(`/units/${deleteItemId}`);
      message.success(t("delete_success"));
      await getApiUnitsWithParents(); // Refresh data
      setDeleteItemId(null);
      setIsDeleteModalVisible(false);
    } catch (error) {
      message.error(t("delete_error"));
    }
  };

  const columns = [
    {
      title: <span style={{ fontWeight: "bold" }}>ID</span>,
      key: "index",
      render: (text, record, index) => index + 1,
      filteredValue: [searchText],
      onFilter: (value, record, index) => {
        return (
          record.name.toLowerCase().includes(value.toLowerCase()) ||
          String(index + 1).includes(value)
        );
      },
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("unit")}</span>,
      dataIndex: "name",
      key: "name",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("یەکەی سەرەکی")}</span>,
      key: "parentUnit",
      render: (text, record) => {
        return parentUnits[record.parent_unit_id] || t("N/A");
      },
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("delete")}</span>,
      key: "action",
      render: (text, record) => (
        <Button
          type="danger"
          style={{ background: "red", border: "red", color: "white" }}
          onClick={() => handleDelete(record.id)}
        >
          <DeleteOutlined />
        </Button>
      ),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("edit")}</span>,
      key: "edit",
      render: (text, record) => (
        <Link to={`/GetUnit/UpdateUnit/${record.id}`}>
          <Button type="primary" icon={<EditOutlined />}></Button>
        </Link>
      ),
    },
  ];

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <div className="list-page">
      <Input.Search
        placeholder={t("searchHere")}
        style={{ marginBottom: 15, marginTop: 12, width: 300 }}
        onSearch={(value) => setSearchText(value)}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <Button
        type="primary"
        className="scroll-to-top-button"
        onClick={scrollToTop}
      >
        <ArrowUpOutlined />
      </Button>
      <Link to="/AddUnit">
        {" "}
        <Button type="primary" className="navigate-to-new-page-button">
          <PlusOutlined />
        </Button>
      </Link>
      <Table
        dataSource={dataSource.map((item) => ({ ...item, key: item.id }))}
        columns={columns}
        pagination={{ pageSize: 50 }}
        scroll={{ x: 800 }}
      />

      {/* Delete Confirmation Modal */}
      <Modal
        style={{ direction: "rtl" }}
        title={t("confirmDelete")}
        open={isDeleteModalVisible}
        onOk={handleConfirmedDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText={t("confirm")}
        cancelText={t("cancel")}
      >
        <p>{t("confirmDeleteMessageUnit")}</p>
      </Modal>
    </div>
  );
};

export default GetUnit;